import { ReactNode } from "react";
import { Link, To } from "react-router";
import { twMerge } from "tailwind-merge";
import { TabbedListHeader } from "./TabbedListHeader";
import { useTabbedListScrollRestoration } from "./useTabbedListScrollRestoration";

type RouteTabbedListItem<TabName extends string> = {
  label: ReactNode;
  name: TabName;
  panel: ReactNode;
  to: To;
};

export const RouteTabbedList = <TabName extends string>({
  ariaLabel,
  headerContent,
  selectedTab,
  tabs,
}: {
  ariaLabel: string;
  headerContent?: ReactNode;
  selectedTab: TabName;
  tabs: RouteTabbedListItem<TabName>[];
}) => {
  const saveScrollPosition = useTabbedListScrollRestoration(selectedTab);
  const selectedPanel = tabs.find((tab) => tab.name === selectedTab)?.panel;

  return (
    <>
      <TabbedListHeader>
        <nav aria-label={ariaLabel} className="flex divide-x">
          {tabs.map((tab) => {
            const selected = tab.name === selectedTab;

            return (
              <Link
                key={tab.name}
                aria-current={selected ? "page" : undefined}
                className={twMerge(
                  "flex h-10 min-w-[120px] flex-1 cursor-pointer items-center justify-center border-b-[3px] border-b-transparent bg-white font-semibold whitespace-nowrap transition-colors hover:bg-gray-50 dark:bg-zinc-900 dark:text-zinc-300 dark:hover:bg-zinc-800",
                  selected &&
                    "border-b-black font-bold dark:border-b-white dark:text-white",
                )}
                onClick={saveScrollPosition}
                replace
                to={tab.to}
              >
                <span className="flex items-center gap-1">{tab.label}</span>
              </Link>
            );
          })}
        </nav>
        {headerContent}
      </TabbedListHeader>
      {selectedPanel}
    </>
  );
};
